import React from "react";

import CopyToFromRow from "components/BudgetBuilder/Setup/CopyToFrom/CopyToFromRow";

import styles from "./styles.css";

const CopyToFrom = ({ copyToFrom, budgetPeriods, editable, onChange }) => {
	const onAdd = () => {
		let newCopyToFrom = [ ...copyToFrom ];
		newCopyToFrom.push({});
		onChange(newCopyToFrom);
	};

	const onRemove = index => {
		const newCopyToFrom = [ ...copyToFrom ];
		newCopyToFrom.splice(index, 1);
		onChange(newCopyToFrom);
	};

	const onRowChange = (index, newData, type) => {
		let newCopyToFrom = [ ...copyToFrom ];
		newCopyToFrom[index] = {
			...newCopyToFrom[index],
			...newData,
		};
		onChange(newCopyToFrom);
	};

	return (
		<div>
			<div className="ui grid">
				<div className="row">
					<div className="sixteen wide column">
						<span className={styles.bold}>{"Copy Data Between Periods"}</span>
					</div>
				</div>
				<div className="row">
					<div className="three wide computer seven wide device column">{"Copy From"}</div>
					<div className="three wide computer seven wide device column">{"Copy To"}</div>
				</div>
				{copyToFrom?.map((row, index) => (
					<div className="row" key={index}>
						<CopyToFromRow
							editable={editable}
							onRowChange={onRowChange}
							onAdd={onAdd}
							onRemove={onRemove}
							rowData={row}
							index={index}
							periods={budgetPeriods?.periodRows}
							size={copyToFrom.length}
						/>
					</div>
				))}
			</div>
		</div>
	);
};

export default CopyToFrom;
